<template>
  <div class="setting-main-container">
    <div class="card setting-card">
      <div class="page-header d-flex justify-content-between">
        <div>
          <h3 class="page-title">
            {{ $t('settings.document_types.title') }}
          </h3>
        </div>
        <base-button
          outline
          class="add-new-tax"
          color="theme"
          @click="openDocumentTypeModal"
        >
          {{ $t('settings.document_types.add_document_type') }}
        </base-button>
      </div>

      <table-component
        ref="table"
        :show-filter="false"
        :data="documentTypes"
        table-class="table tax-table"
        class="mb-3"
      >
        <table-column
          :sortable="true"
          :label="$t('settings.document_types.name')"
          show="name"
        />
        <table-column
          :sortable="true"
          :label="$t('settings.document_types.attach')"
          show="attach"
        />
        <table-column
          :sortable="false"
          :filterable="false"
          cell-class="action-dropdown"
        >
          <template slot-scope="row">
            <span>{{ $t('settings.tax_types.action') }}</span>
            <v-dropdown>
              <a slot="activator" href="#">
                <dot-icon />
              </a>
               <v-dropdown-item>
                <div class="dropdown-item" @click="EditDocumentTypeModal(row.id)">
                  <font-awesome-icon :icon="['fas', 'pencil-alt']" class="dropdown-item-icon" />
                  {{ $t('general.edit') }}
                </div>
              </v-dropdown-item>
              <v-dropdown-item>
                <div class="dropdown-item" @click="removeDocumentType(row.id)">
                  <font-awesome-icon :icon="['fas', 'trash']" class="dropdown-item-icon" />
                  {{ $t('general.delete') }}
                </div>
              </v-dropdown-item>
            </v-dropdown>
          </template>
        </table-column>
      </table-component>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      id: null,
      formData: {
        tax_per_item: false
      }
    }
  },
  computed: {
    ...mapGetters('documentType', [
      'documentTypes',
    ])
  },
  created(){
      this.loadData();
  },
  mounted () {},
  methods: {
    ...mapActions('documentType', [
      'AllDocumentTypes',
      'deleteDocumentType',
      'EditDocumentType'
    ]),
    ...mapActions('modal', [
      'openModal'
    ]),
    refreshTable (val) {
        this.$refs.table.refresh()
    },
    async loadData () {
        let response = await this.AllDocumentTypes()
    },
    async removeDocumentType (id) {
        let response = await this.deleteDocumentType(id)
        if (response.data.success) {
            window.toastr['success'](this.$tc('settings.document_types.deleted_message'))
            this.$refs.table.refresh()
            return true
        }else if(response.data.error) {
          window.toastr['error'](this.$tc('settings.document_types.error_deleted_message'))
        }
    },
    openDocumentTypeModal () {
        this.openModal({
            'title': this.$t('settings.document_types.add_document_type'),
            'componentName': 'DocumentTypeModal'
        })
        this.$refs.table.refresh()
    },
    async EditDocumentTypeModal (id) {
        let response = await this.EditDocumentType(id)
        this.openModal({
            'title': this.$t('settings.document_types.edit_document_type'),
            'componentName': 'DocumentTypeModal',
            'id': response.data.documentType.id,
            'data': response.data.documentType
        })
        this.$refs.table.refresh()
    }
  }
}
</script>
